/* Polymeric Sand Store helpers for Homestead: money, images, cart add that opens the theme's own cart drawer, and a small toast. */
(function () {
  window.PSS = window.PSS || {};
  var P = window.PSS;
  P.root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  P.money = function (cents) {
    var n = Number(cents) / 100; var s = n.toFixed(2); var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  };
  P.img = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300); };
  P.add = function (items) {
    return fetch(P.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (j) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        setTimeout(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true })); }, 350);
        return j;
      });
  };
  P.toast = function (o) {
    var t = document.querySelector('.pss-toast'); if (!t) { t = document.createElement('div'); t.className = 'pss-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = o.title || ''; t.classList.toggle('is-error', !!o.error); t.classList.add('is-on');
    clearTimeout(t.__h); t.__h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  };
})();
